import { useEffect, useRef } from "react";

import { Spinner } from "@/components/Spinner";

export function LoadMoreSpinner({
  fetchNextPage,
  isLoading,
}: {
  fetchNextPage: () => Promise<unknown>;
  isLoading: boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const activePromise = useRef<Promise<unknown> | null>(null);
  const observer = useRef<IntersectionObserver | null>(null);
  const timeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!ref.current || isLoading) return;

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting && !activePromise.current) {
        if (timeout.current) {
          clearTimeout(timeout.current);
        }

        activePromise.current = fetchNextPage().then(() => {
          activePromise.current = null;
          observer.current?.unobserve(ref.current as Element);

          timeout.current = setTimeout(() => {
            observer.current?.observe(ref.current as Element);
          }, 1000);
        });
      }
    });

    observer.current.observe(ref.current);

    return () => {
      observer.current?.disconnect();
    };
  }, [fetchNextPage, isLoading]);

  return (
    <div ref={ref} className="h-20 w-full flex items-center justify-center">
      <Spinner delay={0} />
    </div>
  );
}
